/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconImage from 'DesignSystem/Svgs/TysiaIconImage/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Events/Content/Content/Content/Content/Events/Content/Compact/Past/Content/Content/ActionsCell/ImagesAction/Content",
  hovered,
  onMouseEnter,
  onMouseLeave
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let eventAppointmentHasImagesValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.has_images',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  hovered,
  onMouseEnter,
  onMouseLeave
  
})
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 hovered={hovered}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--ml-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 title={!eventAppointmentHasImagesValueData ? "Images required" : "Open images"}
 onClick={onClick}
 data="event.appointment.has_images"
 disabled={!eventAppointmentHasImagesValueData}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconImage
{...childProps}
  viewPath={`${viewPath}/TysiaIconImage`}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
</div>
{children}
</React.Fragment>)
}